import "./CategoryFlyouts.scss";
import { ReactComponent as ArrowDiagonal } from "./../../assets/images/arrow-diagonal.svg";
import { ReactComponent as Cross } from "./../../assets/images/cross.svg";
import { CategoryFlyout } from "./CategoryFlyout";
import { CategoryNotFound } from "./CategoryNotFound";
import { Link } from "wouter";
import { AnimatePresence } from "framer-motion";

export function CategoryFlyouts({ category }) {
	return (
		<div className="category-flyouts">
			<div className="category-flyouts__controls">
				<div className="category-flyouts__buttons">
					<Link href="/tech-radar/category/access">
						<button
							className={`category-flyouts__button category-flyouts__button--access ${
								category?.slug === "access"
									? "category-flyouts__button--active"
									: ""
							}`}>
							Access <ArrowDiagonal />
						</button>
					</Link>
					<Link href="/tech-radar/category/immersion">
						<button
							className={`category-flyouts__button category-flyouts__button--immersion ${
								category?.slug === "immersion"
									? "category-flyouts__button--active"
									: ""
							}`}>
							Immersion <ArrowDiagonal />
						</button>
					</Link>
					<Link href="/tech-radar/category/transaction">
						<button
							className={`category-flyouts__button category-flyouts__button--transaction ${
								category?.slug === "transaction"
									? "category-flyouts__button--active"
									: ""
							}`}>
							Transaction <ArrowDiagonal />
						</button>
					</Link>
				</div>
				<Link href="/tech-radar">
					<button className="category-flyouts__flyouts-close">
						<Cross />
					</button>
				</Link>
			</div>
			<div className="category-flyouts__flyouts">
				<AnimatePresence exitBeforeEnter={true}>
					{category ? (
						<CategoryFlyout
							title={category?.title}
							content={category?.content}
							key={category?.slug}
						/>
					) : (
						<CategoryNotFound />
					)}
				</AnimatePresence>
			</div>
		</div>
	);
}
